<template>
    <div>
        <PCContactUs 
            v-if="isMobile === false" 
            :infor="infor" 
        />
        <MobContactUs 
            v-else-if="isMobile === true" 
            :infor="infor" 
        />
    </div>
</template>

<script>

    import PCContactUs from '@/components/pc/PCContactUs'
    import MobContactUs from '@/components/mobile/MobContactUs'

    import BMap from 'b-map'
    
    // import Vue from 'vue'
    // import BMap from 'vue-baidu-map'
    // Vue.use(BMap, {
    //   ak: 'akvmX8XMuWpo95TDSFK89jQCyhRGMaS9'
    // })

    export default {
        name: 'ContactUs',
        props: {
            isMobile: Boolean
        },
        components: {
            PCContactUs,
            MobContactUs
        },
        data: function(){
            return {
                infor: {
                    title: "联系我们",
                    bottomTitle: "公司地址"
                }
            }
        },
        methods: {
            getBDMap: function(){
                var map = new BMap.Map("contactBDMap");
                // 创建地图实例  
                // var point = new BMap.Point(116.470759,39.955469);
                var point = new BMap.Point(116.471983,39.955617);

                
                // 创建点坐标  
                map.centerAndZoom(point, 20);
                // 初始化地图，设置中心点坐标和地图级别

                map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放 

                // var marker = new BMap.Marker(point);  // 创建标注
                // map.addOverlay(marker); 

                // marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画

                // //创建小狐狸
                var pt = new BMap.Point(116.471983,39.955617);
                var myIcon = new BMap.Icon("./images/marker_red_sprite.png", new BMap.Size(39, 35));
                var marker = new BMap.Marker(pt,{icon:myIcon});  // 创建标注
                map.addOverlay(marker); 
                // marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画

                var opts = {
                  position : point,    // 指定文本标注所在的地理位置
                  offset   : new BMap.Size(3, -20)    //设置文本偏移量
                }
                var label = new BMap.Label("喜得数字技术", opts);  // 创建文本标注对象
                    label.setStyle({
                         color : "#fff",
                         fontSize : "12px",
                         height : "20px",
                         lineHeight : "20px",
                         fontFamily:"微软雅黑",
                         border: "0px #FF764E solid",
                         borderRadius: "3px",
                         padding: "5px 10px",
                         background: "rgba(255, 118, 78, .9)",
                     });
                map.addOverlay(label);  
            }
        }

    }
</script>
